var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-center my-7.5"
  }, [_c('h1', {
    staticClass: "font-medium"
  }, [_vm._v("\n    " + _vm._s(_vm.price) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-lg mt-2"
  }, [_vm._v("\n    €\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-base self-end text-center mb-4"
  }, [_vm._v("\n    HT\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xl self-end text-center mb-3 ml-3"
  }, [_vm._v("\n    /an\n  ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }